// React
import { useContext } from "react"

// Components
import { NumberInput } from "components"

// Contexts
import { DisabledContext } from "../../contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function PaymentDeposit(): JSX.Element {
  // Hooks
  const disabled = useContext(DisabledContext)

  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="deposit_amount"
      control={control}
      render={({ field, fieldState }) => (
        <NumberInput
          decimalSeparator="."
          inputClass="text-right"
          label="PAYMENT FROM DEPOSIT"
          thousandSeparator=","
          disabled={disabled}
          error={fieldState.error?.message}
          value={field.value}
          ref={field.ref}
          onValueChange={value => field.onChange(value.floatValue ?? 0)}
        />
      )}
    />
  )
}